import {
  HEX,
  SCALING,
  SF_,
  Targeting
} from "../../../src";
const fireball = {
  slug: "fireball",
  name: "Fireball",
  abilityIcon: "fireball",
  description: "Hurls a fiery orb that explodes on impact",
  costs: [{ stat: "mana", value: 30 }],
  targeting: Targeting.MissileMid,
  cooldown: 0,
  projectileSpeed: 6,
  // Slower than arrows
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.FIRE
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ],
    [48]: [
      {
        hexes: HEX.CIRCLE_2,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                red: {
                  type: "chance",
                  min: SF_(1.5),
                  max: SF_(2),
                  qualityScaling: SF_(0.2),
                  rating: 1
                }
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ],
    [96]: [
      {
        hexes: HEX.CIRCLE_3,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                red: {
                  type: "chance",
                  min: SF_(0.8),
                  max: SF_(1.2),
                  qualityScaling: SF_(0.15),
                  rating: 1
                }
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  effectTemplate: "Impact: {0}\nRing 1: {1}\nRing 2: {2}",
  tags: ["spell", "ranged", "aoe", "red"]
};
export {
  fireball
};
//# sourceMappingURL=data:application/json;base64,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
